// extracted by mini-css-extract-plugin
export default {"modal":"VO-z","modalOverlay":"WO-z","outfitHeading":"XO-z"};